export default __webpack_public_path__ + "static/media/Cyclope-1-Blue-24x24.fbca935b.svg";